import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Icon, Message} from 'aui-react';
import classnames from 'classnames';

import {sendEventKbArticleClick} from '../../../analytics';
import {commonPropTypes, eventTypes} from '../../../constants/';

import styles from './row.less';

export default class Row extends PureComponent {
    static propTypes = {
        event: commonPropTypes.event.isRequired,
        helpLinkText: PropTypes.string,
    };

    static defaultProps = {
        helpLinkText: '',
    };

    onHelpLinkClick = () => sendEventKbArticleClick(this.props.event.eventId);

    getLink(className) {
        const {event, helpLinkText} = this.props;
        if (!event.helpLink) {
            return null;
        }
        return <a className={className} href={event.helpLink} onClick={this.onHelpLinkClick} target="_blank">{helpLinkText}</a>;
    }

    getErrorRow() {
        return (
            <div className={styles.errorWrapper} data-wd-id="new-event">
                <Message type="error">
                    <div>
                        <h5 className={styles.title}>{this.props.event.title}</h5>
                        <p dangerouslySetInnerHTML={{__html: this.props.event.description}} />
                        {this.getLink(classnames('aui-button aui-button-primary', styles.errorButtonLink))}
                    </div>
                </Message>
            </div>
        );
    }

    getRow() {
        const {description, title, type} = this.props.event;
        const iconType = type === eventTypes.success ? 'approve' : 'warning';
        const iconClass = type === eventTypes.success ? styles.successIcon : styles.warningIcon;

        return (
            <div className={styles.wrapper} data-wd-id="new-event">
                <Icon className={classnames(styles.icon, iconClass)} icon={iconType} />
                <h5 className={styles.title}>{title}</h5>
                <p dangerouslySetInnerHTML={{__html: description}} />
                {this.getLink()}
            </div>
        );
    }

    render() {
        const isErrorOrFatal = this.props.event.type === eventTypes.error || this.props.event.type === eventTypes.fatal;
        return isErrorOrFatal ? this.getErrorRow() : this.getRow();
    }
}



// WEBPACK FOOTER //
// ./src/components/NewEventsTable/Rows/Row.js